module.exports = __webpack_public_path__ + "img/logo.217346fe.svg";